import React from "react";
import styles from "./PromptButton.module.css";
import {PromptInputField} from "../PromptInputField/PromptInputField";

interface PromptButtonProps {
    value: string;
    onChange: (value: string) => void;
    onDelete?: () => void;
    maxLength?: number;
    placeholder?: string;
}

export const PromptButton: React.FC<PromptButtonProps> = ({
                                                              value,
                                                              onChange,
                                                              onDelete,
                                                              maxLength = 30,
                                                              placeholder = "Button text"
                                                          }) => {
    return (
        <div className={styles.container}>
            <PromptInputField
                value={value}
                setValue={onChange}
                onDelete={onDelete}
                maxLength={maxLength}
                placeholder={placeholder}
                disabled={false}
            />
        </div>
    );
};
